import {z} from "zod/v4-mini"
import {skipped} from "#template/template-node/constants"
import type {VisitorNodeResult} from "#template/template-node/types"
import type {NodeParameters} from "@cm/graph-v3"

export const templateNodeReturns = z.union([
    z.custom<typeof skipped>((val) => val === skipped, {
        message: "Expected a symbol",
    }),
    z.record(z.string(), z.unknown()),
])

export const getTemplateNodeReturns = <T extends NodeParameters>() => {
    return z.custom<VisitorNodeResult<T>>((data) => {
        return templateNodeReturns.safeParse(data).success
    })
}
